import axios from "axios";
import _ from "lodash";
import { toast } from "react-toastify";

import { configHeader } from "@utils/https/configHeader";

const { REACT_APP_API_ENDPOINT, REACT_APP_REQUEST_TIME_OUT } = process.env;

export const fetchAPI = async ({
  method,
  path,
  data = null,
  isAuth = false,
}) => {
  try {
    console.log("url :>> ", `${REACT_APP_API_ENDPOINT}${path}`);
    const response = await axios({
      method,
      url: `${REACT_APP_API_ENDPOINT}${path}`,
      data,
      headers: configHeader({ auth: isAuth }),
      timeout: REACT_APP_REQUEST_TIME_OUT,
    });
    console.log("response in fetchAPI :>> ", response?.data);
    return _.get(response, ["data"]);
  } catch (error) {
    console.log("error in fetchAPI :>> ");
    console.log("error :>> ", error);
    // alert(_.get(error, ["response", "data", "message"]));
    toast.error(_.get(error, ["response", "data", "message"]));
    return _.get(error, ["response", "data"]);
  }
};
